import "./utilities/file-converter";
import '../record-utilities';
import "./utilities/file-uploader";

// Vendor modules
import "angular-dragdrop";
import "angular-filter";
import "angular-ui-bootstrap";
import "angular-uuid";

// Builder
import TemplateBuilderComponent from './template-builder/template-builder.component';
import TemplateOptionsComponent from './template-options/template-options.component';
import TemplatePropertiesComponent from './template-properties/template-properties.component';
import ReferenceOptionsComponent from './reference-options/reference-options.component';
import NewTemplateComponent from './new-template/new-template.component';
import HelpWidgetComponent from './help-widget/help-widget.component';
import TokenForm from './forms/token-form/token-form.component';
import BuilderDataToken from './builder-data-token/builder-data-token.component';
import AdvancedForm from './forms/advanced-form/advanced-form.component';
import FieldBehaviors from './forms/field-behaviors/field-behaviors.component';
import CssBuilder from './forms/css-builder/css-builder.component';
import DoubleList from './forms/double-list/double-list.component';
import CddConfig from './forms/cdd-config/cdd-config.component';
import ToolBoxComponent from './tool-box/tool-box.component';
import FormulasComponent from './build-wizard/formulas/formulas.component';
import SignedTemplateLinkComponent from './build-wizard/signed-template-link/signed-template-link.component';
import BuildPageConfirmComponent from './build-wizard/build-page-confirm/build-page-confirm.component';
import FormulasMenuComponent from './build-wizard/formulas-menu/formulas-menu.component';
import AssociatedTemplateLinksComponent from './build-wizard/associated-template-links/associated-template-links.component';
import SignedLinkSummaryComponent from './build-wizard/signed-link-summary/signed-link-summary.component';
import SignedLinkSummaryBuilder from './build-wizard/signed-link-summary/signed-link-summary-builder.service';
import SearchableSelectComponent from './build-wizard/searchable-select/searchable-select.component';
import NewReferenceComponent from './build-wizard/new-reference/new-reference.component';
import PrefillComponent from './build-wizard/prefill/prefill.component';
import ParentChildComponent from './build-wizard/parent-child/parent-child.component';
import FooterToolsComponent from './footer-tools/footer-tools.component';
import BuilderMenuComponent from './builder-menu/builder-menu.component';
import FormBuilderService from './services/form-builder.service';
import TokenRefreshService from '../services/token-refresh.service';
import ScriptLoaderService from '../services/script-loader.service';
import FieldmapInfoComponent from './build-wizard/fieldmap-info/fieldmap-info.component';
import ConnUpdateComponent from './conn-update/conn-update.component';
import RestoreTemplateComponent from './restore-template/restore-template.component';

//Utilities
import ResizableDirective from './utilities/resizable.directive';
import HasFocusDirective from './utilities/has-focus.directive';
import ContentEditableDirective from './utilities/content-editable.directive';
import BuilderDragMenuDirective from './utilities/builder-drag-menu.directive';
import UserMessage from './utilities/user-message/user-message.component';
import './utilities/mouse-interaction.module';

//Services
import TemplateBuilderService from "./services/template-builder.service";
import UrlClipboardCopyService from "./services/url-clipboard-copy.service";
import TemplateValidationService from "./services/template-validation.service";
import InfoDocService from "./services/info-doc.service";
import FormTemplateListComponent from "./template-list/form-template-list.component";
import UserNotificationComponent from "./user-notification/user-notification.component";
import UserNotificationListComponent from "./user-notification-list/user-notification-list.component";
import GridLines from "./grid-lines/grid-lines.component";
import TokenGroup from "./token-group/token-group.component";
import BuilderTokenMenu from "./builder-token-menu/builder-token-menu.component";
import InfoDocComponent from "./info-doc/info-doc.component";
import BuilderPageMenu from "./builder-page-menu/builder-page-menu.component";
import PageActionArea from "./page-action-area/page-action-area.component";

require('../extensions/jquery-snap-resize');

const DEPENDENCIES = [
  'ui.router',
  'file-converter',
  'file-uploader',
  'record-utilities',
  'ngDragDrop',
  'ui.bootstrap',
  'angular.filter',
  'mouseInteraction',
  'angular-uuid'
];

angular
  .module("app.form-builder", DEPENDENCIES)
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state("app.form-builder", {
        url: "/",
        template: "<form-template-list></form-template-list>",
        data: { title: "Dashboard - Form Engine" },
        resolve: {
          authenticate: ['AuthService', (AuthService) => AuthService.user()]
        }
      })
      .state("app.template-builder", {
        url: "/template-builder/:templateId?:links",
        template: "<template-builder></template-builder>",
        data: { title: "Template Builder - Form Engine" },
        resolve: {
          authenticate: ['AuthService', (AuthService) => AuthService.user()]
        }
      });
  }])
  .run(['$state', 'FlashService', function($state, FlashService) {
    $state.defaultErrorHandler((error) => {
      if (!(error.detail).includes('Not Logged In')) {  //implied by pending redirect
        FlashService.error(`An error occured during navigation: ${error.detail}`);
      }
      const currentState = $state.current.name;

      if (currentState !== "login") {
        $state.go('login', { }); // careful not to create an infinite loop here
      }
    });
  }])
  .directive('resizable', ResizableDirective)
  .directive('hasFocus', HasFocusDirective)
  .directive('contenteditable', ContentEditableDirective)
  .directive('builderDragMenu', BuilderDragMenuDirective)
  .component('templateBuilder', TemplateBuilderComponent)
  .component('templateOptions', TemplateOptionsComponent)
  .component('templateProperties', TemplatePropertiesComponent)
  .component('referenceOptions', ReferenceOptionsComponent)
  .component('tokenForm', TokenForm)
  .component('advancedForm', AdvancedForm)
  .component('fieldBehaviors', FieldBehaviors)
  .component('cssBuilder', CssBuilder)
  .component('doubleList', DoubleList)
  .component('cddConfig', CddConfig)
  .component('builderDataToken', BuilderDataToken)
  .component('userMessage', UserMessage)
  .component('newTemplate', NewTemplateComponent)
  .component('helpWidget', HelpWidgetComponent)
  .component('formTemplateList', FormTemplateListComponent)
  .component('userNotificationList', UserNotificationListComponent)
  .component('userNotification', UserNotificationComponent)
  .component('toolBox', ToolBoxComponent)
  .component('formulas', FormulasComponent)
  .component('signedTemplateLink', SignedTemplateLinkComponent)
  .component('buildPageConfirm', BuildPageConfirmComponent)
  .component('formulasMenu', FormulasMenuComponent)
  .component('associatedTemplateLinks', AssociatedTemplateLinksComponent)
  .component('signedLinkSummary', SignedLinkSummaryComponent)
  .component('searchableSelect', SearchableSelectComponent)
  .component('newReference', NewReferenceComponent)
  .component('prefill', PrefillComponent)
  .component('parentChild', ParentChildComponent)
  .component("footerTools", FooterToolsComponent)
  .component("builderMenu", BuilderMenuComponent)
  .component("gridLines", GridLines)
  .component("tokenGroup", TokenGroup)
  .component("builderTokenMenu", BuilderTokenMenu)
  .component("builderPageMenu", BuilderPageMenu)
  .component("fieldmapInfo", FieldmapInfoComponent)
  .component("pageActionArea", PageActionArea)
  .component("connUpdate", ConnUpdateComponent)
  .component("restoreTemplate", RestoreTemplateComponent)
  .component("infoDoc", InfoDocComponent)

  .service("UrlClipCopy", UrlClipboardCopyService)
  .service("TBService", TemplateBuilderService)
  .service('FormBuilderService', FormBuilderService)
  .service('TemplateValidationService', TemplateValidationService)
  .service('TokenRefreshService', TokenRefreshService)
  .service('InfoDocService', InfoDocService)
  .service('ScriptLoaderService', ScriptLoaderService)
  .service('SignedLinkSummaryBuilder', SignedLinkSummaryBuilder);
